import React, { useState } from "react";
import Button from "components/CustomButton";
import VideoRecorder from "./VideoRecorder";
// import AudioRecorder from "./AudioRecorder";
import NewAudioRecorder from "./NewAudioRecorder";
import ImageRecorder from "./ImageRecorder";
import AudioRecorderTeams from "./MicrosoftTeamsRecorder/AudioRecorderTeams";
import ImageRecorderTeams from "./MicrosoftTeamsRecorder/ImageRecorderTeams";
import { Modal } from "react-responsive-modal";
import VideoEncoder from "./VideoEncoder";
import { useGlobalContext } from "store/contexts/globalContext";
import WebCameraNotAvailable from "./WebCameraNotAvailable";
// eslint-disable-next-line
import Record from "videojs-record/dist/videojs.record.js";
import "videojs-record/dist/css/videojs.record.css";
import "video.js/dist/video-js.css";
import ScreenRecorder from "./ScreenRecorder";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import ScreenRecorderMessage from "components/ScreenRecorderMessage";

const useStyle = {
  recorderDialog: {
    // pointerEvents: 'none',
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1100",
    color: "black",
  },
  recorderDialogBackdrop: {
    height: "inherit",
    width: "inherit",
    position: "fixed",
    backgroundColor: "black",
    top: "0",
    left: "0",
    zIndex: "-1",
    // pointerEvents: 'none !important',
    opacity: "0.7",
  },
  contentContainer: {
    overflow: "hidden",
    padding: "0px !important",
    pointerEvents: "auto",
    width:"400px",
    maxHeight: "70vh",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    flexDirection: "column",
  },
  button: {
    flex: "1",
  },
  closeDailog: {
    backgroundColor: "#16acc0",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    color: "#f4fcfd",
    cursor: "pointer",
    padding: "6px 6px",
    boxShadow:
      "0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",
    transition:
      "box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  closeIcon: {
    height: "1rem",
    fill: "white",
    width: "1rem",
  },
};

export default ({
  showRecorderDialog,
  hide = () => { },
  onChange = () => { },
  selectors,
  type = "video",
  showSelectors = true,
}) => {
  const classes = useStyle;
  const { teamsClient, microsoftConfigureTab } = useGlobalContext();
  const [selectedType, setSelectedType] = useState(
    teamsClient && type !== "image" ? "audio" : type
  );
  const [loading, setLoading] = useState(false);
  const [webCamData, setWebCamData] = useState();
  const [availableRecorders] = useState({
    video: teamsClient ? null : VideoRecorder,
    audio: teamsClient ? AudioRecorderTeams : NewAudioRecorder,
    image: teamsClient ? ImageRecorderTeams : ImageRecorder,
    screen: microsoftConfigureTab ? ScreenRecorderMessage : ScreenRecorder,
  });

  const [types] = useState([
    {
      key: "video",
      value: "Video",
    },
    {
      key: "audio",
      value: "Audio",
    },
    {
      key: "image",
      value: "Image",
    },
    {
      key: "screen",
      value: "Screen",
    },
  ]);
  const preventDefaultOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  const closeDialogAndReturnAttachment = (file) => {
    hide();
    onChange(file);
  };

  const closeDailog = () => {
    if (webCamData) {
      webCamData.dispose();
    }

    hide();
  };

  const Recorder = availableRecorders[selectedType] ?? VideoRecorder;

  return (
    <Modal
      open={showRecorderDialog}
      onClose={() => hide()}
      showCloseIcon={false}
      center={true}
      classNames={{ modal: "recorderPadding" }}
    >
      <div style={classes.contentContainer} onClick={preventDefaultOnClick}>
        <div style={classes.closeDailog}>
          <CloseIcon style={classes.closeIcon} onClick={() => closeDailog()} />
        </div>
        <Recorder
          type={type}
          setWebCamData={setWebCamData}
          onChange={closeDialogAndReturnAttachment}
          setLoading={setLoading}
        />
        {!teamsClient && (
          <WebCameraNotAvailable
            closeDailog={closeDailog}
            setWebCamData={setWebCamData}
            selectedType={selectedType}
            showSelectors={showSelectors}
          />
        )}
        <VideoEncoder loading={loading} />
        <div className="typeButtonContainer">
          {showSelectors &&
            types.map(
              (type) =>
                (!teamsClient || !["Video", "Screen"].includes(type.value)) &&
                selectors.includes(type.key) && (
                  <Button
                    buttonStyle={classes.button}
                    buttonClass="RecorderDialogButton"
                    key={type.key}
                    onClick={() => setSelectedType(type.key)}
                    color="info"
                    disabled={selectedType === type.key}
                  >
                    {type.value}
                  </Button>
                )
            )}
        </div>
      </div>
    </Modal>
  );
};
